export default __webpack_public_path__ + "static/media/avatarB3.aba861bf.png";